import { useEffect, useState } from 'react';
import InfoSidebar from '../../../../../features/InfoSidebar/InfoSidebar';
import NotFound from '../../../../../features/NotFound/NotFoundPage';
import { ButtonPest } from '../../../../../utils/Button';
import cn from '../../../../../utils/cn';
import PackagesTable from './PackagesTable/PackagesTable';
import PricingTable from './PricingTable/PricingTable';
import ServicesTable from './ServiceTable/ServicesTable';

function PackageInfoTitle({ title }) {
    return (
        <div className="py-2.5 px-5 bg-slate-300 rounded-10 mb-3">
            <h2 className="text-primary text-xl font-medium">{title || '--'}</h2>
        </div>
    );
}

function TabButton({ title, onClick, isActive }) {
    return (
        <button
            type="button"
            className={cn(
                'text-base font-medium hover:text-white hover:bg-secondary p-1 px-3 rounded-md transition-colors duration-300',
                {
                    'text-white bg-secondary ': isActive,
                    'text-secondary': !isActive
                }
            )}
            onClick={onClick}
        >
            {title}
        </button>
    );
}

function PackageInfo({ packageInfo, isSelected }) {
    const [tabIndex, setTabIndex] = useState(1);

    if (!isSelected) {
        return (
            <div className="mt-6">
                <NotFound
                    title="No Package Selected!"
                    btnTitle=""
                    evButtonClick={null}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="w-full">
            <PackageInfoTitle title={packageInfo?.packageName} />
            <div className="mb-4 gap-1 bg-secondary-100 inline-flex p-2 py-1.5 rounded-10">
                <TabButton
                    title="Pricing"
                    onClick={() => setTabIndex(1)}
                    isActive={tabIndex === 1}
                />
                <TabButton
                    title="Services"
                    onClick={() => setTabIndex(2)}
                    isActive={tabIndex === 2}
                />
            </div>
            <PricingTable show={tabIndex === 1} />
            <ServicesTable show={tabIndex === 2} />
        </div>
    );
}

function PageTables({ productInfo, openModal, isSelected, isClicked, packageInfo }) {
    const [showMenu, setShowMenu] = useState(false);

    const isProductInactive = productInfo?.status === 'inactive';
    // if any package selected then show info sidebar
    const isDemo = productInfo?.demo === true;
    useEffect(() => {
        if (isSelected) setShowMenu(true);
    }, [isSelected, isClicked]);

    if (productInfo && productInfo?.packages?.length === 0) {
        return (
            <div className="mt-16">
                <NotFound
                    title="No Package Found!"
                    btnTitle="Add Package"
                    evButtonClick={() => openModal('addPackage')}
                    className="h-full [&>img]:max-w-100 [&>button]:text-base [&>button]:h-9 [&>button]:py-0"
                />
            </div>
        );
    }

    return (
        <div className="flex gap-x-5 overflow-hidden">
            <div className="w-full overflow-hidden transition-all duration-[600ms] ease-in-out">
                <div className="mb-3 flex items-center justify-between">
                    <h2 className="text-primary text-xl font-medium">List Of Packages</h2>

                    <ButtonPest
                        title="Add Package +"
                        disabled={isProductInactive || isDemo}
                        onClick={() => openModal('addPackage')}
                    />
                </div>
                <PackagesTable />
            </div>

            <InfoSidebar
                show={showMenu}
                setShow={setShowMenu}
                className="lg:w-[70%] 2xl:w-[60%] 4xl:w-1/2"
            >
                <PackageInfo packageInfo={packageInfo} isSelected={isSelected} />
            </InfoSidebar>
        </div>
    );
}

export default PageTables;
